module.exports = __webpack_public_path__ + "static/img/10.fb7ba9b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/eng/10.png
// module id = H1s1
// module chunks = 0